<template>
    <div>
        <div class="product-item-container">
            
            <!-- Pictos -->
            <div id="pictos-list" class="pictos-list_block">
                <div class="pictos-list picto-item">
                    <!-- Referrer Cobranding Picto -->
                    <img v-if="product.cobrandingPictos"  class="lazyload" :src="product.cobrandingPictos" :data-src="product.cobrandingPictos"/>
                
                    <img v-for="(picto, key) in product.pictos" :key="key" class="lazyload" :src="picto" :data-src="picto"/>
                </div>
            </div>

            <div class="product-item" data-compared="0">
                <a class="link-item" :href="product.productInfos.request_path" :title="product.productInfos.image_label">
                
                    <!-- PODUCT-OP
                    <div v-if="product.markOpdatas.name" class="product-oc-container mobile">
                        <div  class="product-oc" style="background-color:<?php echo $markopdatas; ?>">
                            <span>{{ product.markOpdatas.name }}</span>
                        </div>
                    </div>-->

                    <!-- IMAGE -->
                    <div class="product-image-item">
                        <span class="brand">
                            <img v-if="product.brandImage" class="lazyload" :src="product.brandImage" :data-src="product.brandImage" :alt="product.productBrand"/>   
                        </span>
                        <img 
                            class="lazyload" 
                            :src="product.productImage" 
                            :alt="product.productInfos.image_label"
                            :title="product.productInfos.image_label"
                        />
                    </div>

                    <!-- PODUCT-OP
                    <div v-if="product.markOpdatas.name" class="product-oc-container">
                        <div  class="product-oc" style="background-color:<?php echo $markopdatas; ?>">
                            <span>{{ product.markOpdatas.name }}</span>
                        </div>
                    </div> -->
                </a>

                <!-- PRODUCT INFOS -->
                <div class="product-item-infos">
                    <a class="link-item" :href="product.productInfos.request_path" :title="product.productInfos.image_label">

                        <p class="product-tech">
                            {{product.productUnivers}}
                        </p>
                        
                        <!-- PRODUCT NAME -->
                        <h2 class="product-name">
                            <span v-if="product.productBrand" class="brand">{{ product.productBrand }} </span>
                            <span> {{ product.productInfos.ba_product_line }} </span>
                            <span> {{ product.modelProduct }}</span>
                        </h2>

                        <!-- RATES AND REVIEWS -->
                        <div v-if="product.reviews" class="ratings-wrapper">
                            
                            <div class="ratings-stars">
                                <img 
                                    class="star-bg" 
                                    alt="" 
                                    src="data:image/svg+xml;base64,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" 
                                />
                                <img 
                                    class="star-mask" 
                                    alt="" 
                                    src="data:image/svg+xml;base64,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" 
                                />
                                <div class="progress" :style="'width: calc((' + product.reviews.average + '* 100%) / 5);'"></div>
                            </div>

                            <span class="ratings-average">{{ product.reviews.average.toFixed(1) }}</span>
                            <!-- <span>({{ product.reviews.totalRates }})</span> -->

                            <!-- POPPIN RATINGS -->
                            <div class="popin-ratings">
                                <div class="popin-header">
                                    <div class="ratings-stars">
                                        <img class="star-bg" 
                                            alt="" 
                                            src="data:image/svg+xml;base64,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" 
                                        />
                                        <img 
                                            class="star-mask" 
                                            alt="" 
                                            src="data:image/svg+xml;base64,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" 
                                        />
                                        <div class="progress" :style="'width: calc((' + product.reviews.average + '* 100%) / 5);'"></div>
                                    </div>

                                    <p class="total-rates"> 
                                        {{ product.reviews.totalRates }} avis
                                    </p>
                                </div>
                                
                                <div class="popin-rowsContainer">
                                    <div v-for="(percent, key) in product.reviews.details" :key="key" class="row-detail">
                                        <span class="title-stars">{{ key }} étoile<span v-if="key > 1">s</span></span>
                                        <div class="detail-progress">
                                            <div :style="'width:' + percent + '%'"></div>
                                        </div>
                                        <span class="percent">{{ percent }}%</span>
                                    </div>
                                </div>

                                <a class="see-all" :href="product.productInfos.request_path+'#reviews'" title="Voir tous les commentaires">Voir tous les commentaires</a>
                            </div>
                        </div>
                        <!-- IF NO REVIEWS -->
                        <div v-else class="empty-reviews"></div>
                    </a>
                </div>
                

                <!-- PRICE -->
                <ProductPriceCart
                    :originalPrice="originalPrice"
                    :special-price="specialPrice"
                ></ProductPriceCart>
            
            </div>

        </div>
    </div>
</template>

<script>
import ProductPriceCart from "@/includes/Product/ProductPrice/ProductPriceCart.vue";

export default {
    name: "ProductItemCard",

    components: { 
        ProductPriceCart 
    },

    props: ["product", "positionInList"],


    data() {
        return {
            originalPrice: 0,
            specialPrice: 0,
        };
    },

    created() {
        this.specialPrice = parseFloat(this.product.productInfos.final_price) + (parseFloat(this.product.productInfos.final_price) / parseFloat(this.product.productInfos.tax_percent))
        this.originalPrice = parseFloat(this.product.productInfos.price) + (parseFloat(this.product.productInfos.price) / parseFloat(this.product.productInfos.tax_percent))
    },

};

</script>

<style lang="scss" >
    .product-item-container{
        border: none;

        //Pictos list
        .pictos-list_block {
            top: 0;

            .pictos-list {
                height: 270px;
                justify-content: flex-end;

                @media ($mq-desktop){
                    height: 250px;
                }
                
                img {
                    max-width: 35px;
                }
            }
            
        } 

        //Product Image
        .product-image-item {
            float: none;
            width: auto;
        }

        //Product-infos
        .product-item-infos {
            .ratings-wrapper,
            .empty-reviews {
                height: 25px;
            }

            .ratings-average{
                font-weight: 700;
            }

            .popin-ratings {
                .popin-header {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 10px;

                    .total-rates {
                        margin-top: 0px;
                    }
                }

                .popin-rowsContainer{
                    display: flex;
                    flex-direction: column-reverse;
                }
            }
        }
        

        //Price
        .ProductPrice.Cart {
            flex-direction: row-reverse;
            justify-content: start;
            align-items: start;
            padding: 10px 15px;

            .ProductPrice-infoPrice{
                margin-left: 0;
                align-items: flex-start;
            }

            .priceBig {
                color: $color-red;
            }
        }


    }
</style>